export const RICH_TEXT_TOOL_BAR = 'Tools';
